export default "__VITE_ASSET__CUMi4QzV__"